import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-remind",
  "use": "icon-remind-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-remind\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 78c239.7 0 434 194.3 434 434S751.7 946 512 946 78 751.7 78 512 272.3 78 512 78z m1 628c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40z m0-464c-22.1 0-40 17.9-40 40v304c0 22.1 17.9 40 40 40s40-17.9 40-40V282c0-22.1-17.9-40-40-40z\" p-id=\"16240\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/remind.svg
// module id = azJ5
// module chunks = 7